

import { useContext, useEffect, useRef, useState } from 'react'
import imageCompression from "browser-image-compression";


import 'bootstrap-daterangepicker/daterangepicker.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../../components/hooks/useForm';
import { BanksContext } from '../../context/bank/BankContext';
import Message from '../../components/ui/Message';
import { ProductsContext } from '../../context/products/ProductContext';
import SearchProduct from './SearchProduct';
import { event } from 'jquery';
import { Caby } from '../../models/interfaces';
import SearchByCode from './SearchByCode';
import SearchByCategory from './SearchByCategory';
import { useRequiredFields } from '../../hooks/useRequiredFields';
import FormModal from '../../components/ui/FormModal';
import { AuthContext } from '../../context/auth';
import { catalogName, isPanamaMerchant, PANAMA_ITBMS_TAX_CODE } from '../../utils/productTax';


export const ProductPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [isFormValid, setIsFormValid] = useState(false);
    const { banks } = useContext(BanksContext)
    //const { groups, merchants, addProduct, updateProduct,loadMerchantsAndGroups, clearSuggestions, suggestions } = useContext(ProductsContext);
    const [existProductMsg, setExistProductMsg] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const required = useRequiredFields();
    const [successMessage, setSuccessMessage] = useState('');
    const { products, getMenusAndSubmenus, addMenu, loadProducts, addProduct, updateProduct, selectedCabys, loadTaxCode, loadUnits } = useContext(ProductsContext);
    const [uploadImage, setUploadImage] = useState(null);
    const [preview, setPreview] = useState(null);


    const [menus, setMenus] = useState([]);
    // Alta rápida de menú / categoría sin salir del formulario
    const [newMenu, setNewMenu] = useState<{ name: string; parentId: number } | null>(null);
    const [newMenuError, setNewMenuError] = useState('');
    const [savingMenu, setSavingMenu] = useState(false);
    const pendingMenu = useRef<{ name: string; knownIds: number[] } | null>(null);
    const [searchCabysProduct, setSearchCabysProduct] = useState(false);
    const [units, setUnits] = useState([]);
    const [taxCodes, setTaxCodes] = useState([]);
    // El código del producto sale del catálogo del país: código de hacienda (CR) o Codificación Panameña de Bienes y Servicios (PA)
    const { user } = useContext(AuthContext);
    const isPanama = isPanamaMerchant(user?.merchant);
    const catalogLabel = catalogName(user?.merchant);
    var product;


    if (state) {
        // En la lista "price" es el precio vigente (oferta incluida); aquí se edita el de catálogo
        product = {
            ...state.product,
            price: state.product.regularPrice ?? state.product.price,
            promoPrice: state.product.promoPrice ?? '',
            promoStart: state.product.promoStart ?? '',
            promoEnd: state.product.promoEnd ?? '',
        };
        //setUndef(product.available > 10000);

    } else {
        product = {
            id: -1,
            menuId: -1,
            name: '',
            codeId: '',
            shortDescription: '',
            price: '',
            available: 10,
            taxCodeId: '',
            unit: '',
            enableCustomPrice: false,
            promoPrice: '',
            promoStart: '',
            promoEnd: ''
        }
    }


    const { formState, onInputChange } = useForm(product);

    var { id, name, codeId, shortDescription, price, menuId, image, available, taxCodeId, unit, enableCustomPrice, promoPrice, promoStart, promoEnd } = formState

    // Oferta: precio menor al regular y sus fechas (si tiene precio de oferta)
    const hasPromo = promoPrice !== '' && promoPrice !== null && Number(promoPrice) > 0;
    const promoError = !hasPromo ? ''
        : Number(promoPrice) >= Number(price) ? 'El precio de oferta debe ser menor al precio regular.'
            : !promoStart || !promoEnd ? 'Indique las fechas de inicio y fin de la oferta.'
                : promoEnd < promoStart ? 'La fecha de fin debe ser igual o posterior a la de inicio.'
                    : '';

    // La lista se actualiza cuando cambian los menús (por ejemplo, al crear uno desde aquí); el creado queda seleccionado
    useEffect(() => {
        getMenusAndSubmenus().then((menus) => {
            setMenus(menus);
            const pending = pendingMenu.current;
            const created = pending && menus.find(menu => menu.name === pending.name && !pending.knownIds.includes(menu.id));
            if (created) {
                pendingMenu.current = null;
                onInputChange({ target: { name: 'menuId', value: created.id } });
            }
        })
    }, [products])   // eslint-disable-line react-hooks/exhaustive-deps

    const saveNewMenu = async () => {
        const name = newMenu?.name.trim() ?? '';
        if (!name) {
            setNewMenuError('Ingrese el nombre del menú / categoría.');
            return;
        }
        setSavingMenu(true);
        setNewMenuError('');
        pendingMenu.current = { name, knownIds: menus.map(menu => menu.id) };
        const parentId = newMenu!.parentId > 0 ? newMenu!.parentId : null;
        const resp = await addMenu({ id: -1, name, parentId } as any);
        setSavingMenu(false);
        if (resp !== 'success') {
            pendingMenu.current = null;
            setNewMenuError(resp);
            return;
        }
        setNewMenu(null);
        if (parentId) loadProducts();   // un submenú se recarga para que quede dentro de su menú
    }


    useEffect(() => {
        loadTaxCode().then((codes) => {
            setTaxCodes(codes)
            // Producto nuevo en Panamá: ITBMS por defecto
            if (!state && isPanama && codes?.some(code => String(code.id) === PANAMA_ITBMS_TAX_CODE)) {
                onInputChange({ target: { name: 'taxCodeId', value: PANAMA_ITBMS_TAX_CODE } });
            }
        });

    }, [])

    useEffect(() => {
        loadUnits().then((units) => {
            setUnits(units)
        });
    }, [])

    useEffect(() => {
        if (state) {
            setCabys(product.cabysDetails)
            if (image) {
                var urlImage = process.env.REACT_APP_IMAGES_URL + image;
                fetch(urlImage, { method: 'HEAD' }).then((response) => {
                    if (response.ok) {
                        setPreview(urlImage);
                    }
                });
            }


        } else {
            setCabys(null);
        }
    }, [])

    const [activeTab, setActiveTab] = useState('code'); // 'code' or 'category'
    const { setCabys } = useContext(ProductsContext);

    const handleValueSelect = (value: Caby) => {
        //setSelectedValue(`${value.CodigoBienServicio} - ${value.DescripcionBienServicio}`);
        //alert(`Producto seleccionado: ${value.CodigoBienServicio} - ${value.DescripcionBienServicio}`);

        setCabys(value);
        setSearchCabysProduct(false);
    };

    const handleTab = (opcion: string, event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        setActiveTab(opcion);
    };



    const searchProduct = (event) => {
        event.preventDefault();
        navigate("/search-product");
    }


    const handleSave = async () => {


        var resp = "";

        const formValid = name.length > 0 && menuId > 0 && parseInt(price) > 0 && parseInt(taxCodeId) > 0 && unit.length > 0;

        if (!formValid) {
            required.fail();
            setErrorMessage('Por favor complete todos los campos requeridos.');
            return;
        }

        if (promoError) {
            setErrorMessage(promoError);
            return;
        }

        if (selectedCabys == null) {
            required.fail();
            setErrorMessage(`${catalogLabel} es requerido.`);
            return;
        }

        var product = formState;
        product.cabysCode = selectedCabys.CodigoBienServicio;
        product.image = uploadImage;




        if (id > 0) {
            resp = await updateProduct(product);
        } else {
            resp = await addProduct(product, menuId);
        }
        if (resp == "success") {
            setSuccessMessage(id > 0 ? "Producto actualizado correctamente" : "Producto creado correctamente.");
        } else {
            setErrorMessage(resp);
            setExistProductMsg(resp);
        }
    }


    const removeSucessMessage = () => {
        setSuccessMessage('');
        navigate(-1);

    }

    const removeError = () => {
        setErrorMessage('');
    }

    // Las imágenes se reducen antes de subirlas: en el menú QR se muestran pequeñas y una
    // imagen original (a veces de más de 1 MB) hace que el menú tarde en cargar
    const handleImageChange = async (event) => {
        const original = event.target.files[0];
        if (!original) return;

        setPreview(URL.createObjectURL(original)); // Mostrar una vista previa

        let file: Blob = original;
        try {
            file = await imageCompression(original, {
                maxSizeMB: 0.3,
                maxWidthOrHeight: 800,
                useWebWorker: true,
                fileType: 'image/webp',
                initialQuality: 0.8,
            });
        } catch (error) {
            // Si no se puede comprimir se sube la imagen original
            file = original;
        }

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                // Obtén el resultado en formato Base64 (reader.result)
                const base64Image = reader.result;

                setUploadImage(base64Image);
            };
            reader.readAsDataURL(file);

        }

    };



    return (

        searchCabysProduct ?
            (<>
                <div className="container mt-4">
                    <h2 className="mb-4">Buscar Productos</h2>

                    {/* Input para mostrar el valor seleccionado */}
                    {/* <div className="input-group mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Seleccione un valor"
          value={selectedValue}
          readOnly
        />
      </div> */}

                    {/* Navbar para alternar entre búsquedas */}
                    <ul className="nav nav-tabs mb-3">
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'code' ? 'active' : ''}`}
                                onClick={(event) => handleTab('code', event)}
                            >
                                Búsqueda por Código o Descripción
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'category' ? 'active' : ''}`}
                                onClick={(event) => handleTab('category', event)}
                            >
                                Búsqueda por Categoría
                            </button>
                        </li>
                    </ul>

                    {/* Paneles de Búsqueda */}
                    {activeTab === 'code' && <SearchByCode onSelect={handleValueSelect} />}
                    {activeTab === 'category' && <SearchByCategory onSelect={handleValueSelect} />}
                    <div className='container d-flex align-items-center justify-content-center mt-5'>
                        <button type="button" onClick={(event) => setSearchCabysProduct(false)} className="btn btn-outline-secondary">Atrás</button>


                    </div>
                </div>


            </>)
            :
            (<>
                <div className='container d-flex align-items-center justify-content-center mt-5' style={styles.container}>


                    <div className='col-md-6'>
                        <h3>{id > 0 ? 'Actualizar producto' : 'Crear producto'}</h3>
                        <hr />

                        <form className="row g-3 " >

                            <div className="mb-3 ">
                                <label htmlFor="menuIdSelect" className="form-label">Menú / Categoría *</label>
                                <div className="d-flex gap-2">
                                    <select id='menuIdSelect' className={`form-select${required.mark(!(menuId > 0))}`} name='menuId' value={menuId} onChange={onInputChange} >
                                        <option key={-1} value={-1} >Seleccione una opción</option>
                                        {menus.length > 0
                                            ?
                                            menus.map(productPrincipal => (
                                                <option key={productPrincipal.id} value={productPrincipal.id}>{productPrincipal.name}</option>
                                            ))
                                            :
                                            <option disabled>No hay menús / categorías configurados</option>
                                        }
                                    </select>
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary text-nowrap"
                                        onClick={() => { setNewMenu({ name: '', parentId: -1 }); setNewMenuError(''); }}
                                    >
                                        <i className="bi bi-plus-lg" /> Nueva
                                    </button>
                                </div>
                                {required.mark(!(menuId > 0)) !== '' && <div className="invalid-feedback d-block">Campo requerido</div>}
                                {menus.length === 0 && (
                                    <div className="form-text">Aún no hay menús / categorías. Use <strong>Nueva</strong> para crear el primero.</div>
                                )}
                            </div>



                            <div className="mb-3">
                                <label htmlFor="codeIdInput" className="form-label">Código</label>
                                <input
                                    id='codeIdInput'
                                    type="text"
                                    className={`form-control`}
                                    placeholder="Código"
                                    name="codeId"
                                    value={codeId}
                                    onChange={onInputChange}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label htmlFor="nameInput" className="form-label">Nombre *</label>
                                <input
                                    id='nameInput'
                                    type="text"
                                    className={`form-control${required.mark(!name)}`}
                                    placeholder="Nombre"
                                    name="name"
                                    value={name}
                                    onChange={onInputChange}
                                    required
                                />
                                <div className="invalid-feedback">Campo requerido</div>
                            </div>

                            <div className="mb-3">
                                <label htmlFor="shortDescriptionInput" className="form-label">Descripción</label>
                                <input
                                    id='shortDescriptionInput'
                                    type="text"
                                    className={`form-control`}
                                    placeholder="Descripción"
                                    name="shortDescription"
                                    value={shortDescription}
                                    onChange={onInputChange}
                                    required
                                />
                                <div className="invalid-feedback">Campo requerido</div>
                            </div>

                            <div className="mb-3">
                                <label htmlFor="priceInput" className="form-label">Precio *</label>
                                <input
                                    id='priceInput'
                                    type="number"
                                    className={`form-control${required.mark(!(parseInt(price) > 0))}`}
                                    placeholder="Precio"
                                    name="price"
                                    value={price}
                                    onChange={onInputChange}
                                    min={0}
                                    required
                                />
                                <div className="invalid-feedback">Campo requerido</div>
                            </div>

                            {/* Precio de oferta con vigencia: se cobra en todas las ventas entre las fechas indicadas */}
                            <div className="mb-3 border rounded p-3">
                                <div className="form-label fw-medium mb-2">Precio de oferta</div>
                                <div className="row g-2">
                                    <div className="col-12 col-md-4">
                                        <label htmlFor="promoPriceInput" className="form-label small text-muted mb-1">Precio</label>
                                        <input
                                            id="promoPriceInput"
                                            type="number"
                                            className={`form-control${promoError && Number(promoPrice) >= Number(price) ? ' is-invalid' : ''}`}
                                            placeholder="Sin oferta"
                                            name="promoPrice"
                                            value={promoPrice ?? ''}
                                            onChange={onInputChange}
                                            min={0}
                                        />
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <label htmlFor="promoStartInput" className="form-label small text-muted mb-1">Desde</label>
                                        <input id="promoStartInput" type="date" className="form-control" name="promoStart"
                                            value={promoStart ?? ''} onChange={onInputChange} disabled={!hasPromo} />
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <label htmlFor="promoEndInput" className="form-label small text-muted mb-1">Hasta</label>
                                        <input id="promoEndInput" type="date" className="form-control" name="promoEnd"
                                            value={promoEnd ?? ''} min={promoStart || undefined} onChange={onInputChange} disabled={!hasPromo} />
                                    </div>
                                </div>
                                {promoError
                                    ? <div className="text-danger small mt-2">{promoError}</div>
                                    : <div className="form-text">Fechas incluidas. En la factura se registra como descuento "Precio de oferta". Déjelo vacío para quitar la oferta.</div>}
                            </div>

                            <div className=" mb-3">
                                <label htmlFor="availableInput" className="form-label">Cantidad</label>
                                <input
                                    id='availableInput'
                                    type="number"
                                    className={`form-control  `}
                                    placeholder="Cantidad"
                                    name="available"
                                    value={available}
                                    min={0}
                                    onChange={onInputChange}
                                    required
                                />
                            </div>

                            <div className="mb-3 ">
                                <label htmlFor="unitSelect" className="form-label">Unidad de medida *</label>
                                <select id='unitSelect' className={`form-select${required.mark(!unit)}`} name='unit' value={unit} onChange={onInputChange} >
                                    <option key={-1} value={-1} >Seleccione una opción</option>
                                    {units.length > 0
                                        ?
                                        units.map(productPrincipal => (
                                            <option key={productPrincipal.id} value={productPrincipal.id} >{productPrincipal.description}</option>
                                        ))
                                        :
                                        ''
                                    }
                                </select>
                                <div className="invalid-feedback">Campo requerido</div>
                            </div>

                            <div className="mb-3 ">
                                <label htmlFor="taxCodeSelect" className="form-label">Tipo de impuesto *</label>
                                <select id='taxCodeSelect' className={`form-select${required.mark(!(parseInt(taxCodeId) > 0))}`} name='taxCodeId' value={taxCodeId} onChange={onInputChange} >
                                    <option key={-1} value={-1} >Seleccione una opción</option>
                                    {taxCodes.length > 0
                                        ?
                                        taxCodes.map(productPrincipal => (
                                            <option key={productPrincipal.id} value={productPrincipal.id} >{productPrincipal.description}</option>
                                        ))
                                        :
                                        ''
                                    }
                                </select>
                                <div className="invalid-feedback">Campo requerido</div>
                            </div>

                            {/* En la app (pantalla de supermercado) permite cambiar el precio al vender; no aplica a productos por kg */}
                            <div className="mb-3">
                                <div className="form-check form-switch">
                                    <input
                                        id="enableCustomPriceInput"
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        name="enableCustomPrice"
                                        checked={!!enableCustomPrice}
                                        onChange={onInputChange}
                                    />
                                    <label htmlFor="enableCustomPriceInput" className="form-check-label">Precio editable</label>
                                </div>
                                <div className="form-text">Permite modificar el precio al vender desde la app. No aplica a productos vendidos por kg.</div>
                            </div>

                            {/* <SearchProduct /> */}

                            <div className="mb-1">
                                <label htmlFor="cabysInput" className="form-label">{catalogLabel} *</label>
                                <div className="input-group has-validation mb-3">
                                    <input
                                        id="cabysInput"
                                        type="text"
                                        className={`form-control${required.mark(selectedCabys == null)}`}
                                        placeholder="Seleccione un valor"
                                        value={selectedCabys != null ? selectedCabys.CodigoBienServicio + ' - ' + selectedCabys.DescripcionBienServicio + '(' + selectedCabys.Impuesto + '%)' : ''}
                                        readOnly
                                    />
                                    <button
                                        className="btn btn-primary"
                                        type="button"
                                        onClick={(event) => setSearchCabysProduct(true)}
                                    >
                                        <i className="bi bi-search"></i>
                                    </button>
                                    <div className="invalid-feedback">Seleccione el código</div>
                                </div>

                            </div>

                            <div className="mb-3">
                                <label htmlFor="fileInput" className="form-label">
                                    Selecciona una imagen
                                </label>
                                <input
                                    type="file"
                                    id="fileInput"
                                    className="form-control"
                                    accept=".png, .jpg, .jpeg"
                                    onChange={handleImageChange}
                                />
                                {preview && (
                                    <div style={{ textAlign: 'center', paddingTop: '2%' }}>
                                        <img
                                            src={preview}
                                            alt="Preview"
                                            className="rounded"
                                            style={{
                                                width: "150px",
                                                height: "150px",
                                                objectFit: "cover",
                                            }}
                                        />
                                    </div>
                                )}

                            </div>


                            <div className='container d-flex align-items-center justify-content-center mt-5'>
                                <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">Atrás</button>

                                <button type="button" onClick={handleSave} className="btn btn-primary ms-5" >Guardar</button>
                            </div>
                        </form>
                        <div style={{ height: '100px' }}></div>
                    </div>

                    {
                        errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)' /> : ''
                    }
                    {
                        successMessage.length > 0 ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)' /> : ''
                    }

                    {newMenu && (
                        <FormModal title="Nuevo menú / categoría" subtitle="Queda seleccionado para este producto"
                            onClose={() => setNewMenu(null)} onSave={saveNewMenu} saving={savingMenu} saveLabel="Crear" error={newMenuError}>
                            <div className="mb-3">
                                <label htmlFor="newMenuName" className="form-label">Nombre *</label>
                                <input id="newMenuName" type="text" className="form-control" autoFocus maxLength={100}
                                    value={newMenu.name} onChange={(e) => setNewMenu({ ...newMenu, name: e.target.value })} />
                            </div>
                            <div>
                                <label htmlFor="newMenuParent" className="form-label">Dentro de</label>
                                <select id="newMenuParent" className="form-select" value={newMenu.parentId}
                                    onChange={(e) => setNewMenu({ ...newMenu, parentId: Number(e.target.value) })}>
                                    <option value={-1}>Nivel superior</option>
                                    {menus.map(menu => <option key={menu.id} value={menu.id}>{menu.name}</option>)}
                                </select>
                            </div>
                        </FormModal>
                    )}

                </div>
            </>)

    )
}


const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
